import { defineStore } from 'pinia';
import {
  ref
} from '@nuxtjs/composition-api';


export const useFlowValidationStore = defineStore('flowValidationStore', () => {
  const preValidateInProgress = ref(false)
  const validateInProgress = ref(false)
  const validationResponse = ref(null)
  const validationStatus = ref(null);
  const preValidationStatus = ref(null);
  const signupBlockingNotifications = ref(null)
  const hasSignupBlockingNotification = ref(null)
  const signupBlockingNotificationsValidate = ref(null)
  const hasSignupBlockingNotificationValidate = ref(null)


  return {
    preValidateInProgress,
    validateInProgress,
    validationResponse,
    validationStatus,
    preValidationStatus,
    signupBlockingNotifications,
    hasSignupBlockingNotification,
    signupBlockingNotificationsValidate,
    hasSignupBlockingNotificationValidate
  }
})
